module.exports = __webpack_public_path__ + "catalog/items/instalaciones_87/3D_8.7.obj";